import { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';

//import tags
import { Accordion, AccordionItem } from '@szhsin/react-accordion';

//import resources
import Skeleton from 'react-loading-skeleton';

// //import api
import FetchData from '../../../api/Api';

export default function FaqItems() {

    //get locale
    const { locale } = useParams();

    //get data
    const [data, setData] = useState(null);

    useEffect(() => {

        if (data === null) {
            const fetchData = async () => {
                try {
                    const fetchDataInstance = new FetchData();
                    await fetchDataInstance.initHeaders(locale);
                    const result = await fetchDataInstance.get(`/api/faq`, true);
                    setData(result);
                } catch (error) {
                    console.error("Failed to get data:", error.message);
                }
            };

            fetchData();
        }

    }, [data]);


    useEffect(()=> {
        setData(null);
    }, [locale])


    return (
        <>
           <Accordion>
                {
                    typeof data === 'object' && data !== null ? (
                        data.data.map((item, index) => (
                            <AccordionItem className="p-5 text-left" key={index} header={item.translations[0].question}>
                                <div className='text-left' dangerouslySetInnerHTML={{ __html: item.translations[0].answer }}></div>
                            </AccordionItem>
                        ))
                    ) : (
                        <>
                           <Skeleton height={20} count={6} />
                        </>
                    )
                }

                
            </Accordion>
            
        </>
    );
}


